<script lang="ts">
  import RichText, { hasRichTextContent } from '$components/rich-text.svelte';
  import { cn } from '$lib/utils';

  import type { GetProductQuery } from '$gql/storefront/operations';
  import type { RichtextStoryblok } from '$types/bloks';

  export let doc: RichtextStoryblok | undefined = undefined;
  export let selectedProductVariant:
    | NonNullable<GetProductQuery['product']>['variants']['nodes'][number]
    | undefined = undefined;

  let className: string | undefined = undefined;
  export { className as class };
</script>

{#if doc && hasRichTextContent(doc)}
  <div class={cn('rounded-sm border border-primary/4 bg-primary/2 p-4', className)}>
    <RichText
      {doc}
      richTextBlockProps={{ selectedProductVariant }}
      class={cn(
        '[&>h3+*]:mt-1',
        '[&>h3]:text-sm [&>h3]:font-semibold',
        '[&>p]:text-sm',
        '[&>.rich-text-paragraph-by-variant]:text-sm',
        '[&>p>img]:w-full [&>p>img]:rounded-xs [&>p>img]:border [&>p>img]:border-primary/4 [&>p>img]:object-contain',
        '[&>*+p]:mt-1',
        '[&>*+.rich-text-paragraph-by-variant]:mt-1',
        '[&>*+.rich-text-button-cta]:mt-3',
        '[&>*+.rich-text-metrics]:mt-5',
        '[&>.rich-text-metrics+p]:mt-5',
        '[&>*+.rich-text-button-cta]:hidden' //This is to hide ring sizer button while it's not deleted in storyblok
      )}
    />
  </div>
{/if}
